var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EChart',{staticClass:"shadow-none m-0",attrs:{"options":_vm.chartData,"card":"","header":_vm.$t('availabilityInStores'),"loading":_vm.loading},on:{"click":_vm.handleChartClick}}),_c('ModalAvailabilityInStoresItem')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }